// extracted by mini-css-extract-plugin
module.exports = {"selector":"pGz27M"};